<nz-list
  [nzDataSource]="comments"
  [nzLoading]="loading"
  [nzRenderItem]="comment"
  [nzHeader]="pagination"
>
  <ng-template #comment let-comment>
    <nz-comment
      [nzAuthor]="comment.author"
      [nzDatetime]="(comment.dateTime | date: 'shortDate') ?? undefined"
    >
      <nz-comment-content>
        <p>{{ comment.content }}</p>
      </nz-comment-content>
    </nz-comment>
  </ng-template>

  <ng-template #pagination>
    <div nz-row nzJustify="end">
      <nz-pagination
        [nzPageIndex]="pageIndex"
        [nzPageSize]="pageSize"
        [nzTotal]="totalComments"
        (nzPageIndexChange)="pageChanged($event)"
        (nzPageSizeChange)="pageSizeChanged($event)"
        [nzShowTotal]="rangeTemplate"
        [nzShowSizeChanger]="true"
        [nzPageSizeOptions]="[1, 2, 5, 10, 20]"
      ></nz-pagination>
      <ng-template #rangeTemplate let-range="range" let-total>
        {{ range[0] }}-{{ range[1] }} of {{ total }} items
      </ng-template>
    </div>
  </ng-template>
</nz-list>
